import { useEffect, useState } from 'react';
import { getCssCustomProperty } from '../css.js';

export const useCssCustomProperty = (
  customProperty: string,
  element: HTMLElement = document.documentElement,
): string => {
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue(getCssCustomProperty(customProperty, element));

    // ToDo: Set up a MutationObserver to watch for style changes.
    // This would make the hook reactive to runtime CSS changes
  }, [customProperty, element]);

  return value;
};
